import {Game} from '../Game';
import {RemoveWallsAction} from 'src/Action';
import {wallRenderer} from 'src/Pixi/map/WallRenderer';
import {Location} from '../../common/map/Location';
import {heldRenderer} from "../../Pixi/map/HeldRenderer";

export class RemoveWalls {
    public constructor(public game: Game) {
        // Sets instance variables
    }

    public byServer(action: RemoveWallsAction): void {
        action.locations.forEach( loc => {
            this.game.map.walls[loc.y][loc.x] = null;
        });
        this.game.map.updateHeld();
        wallRenderer.updateTiles(action.locations.map( loc => Location.fromLoc(loc)));
        heldRenderer.redraw();
    }
}



// WEBPACK FOOTER //
// ./src/game/actions/RemoveWalls.ts